// extracted by mini-css-extract-plugin
export default {"card":"WelcomeHero_card__-FVKo","avatar":"WelcomeHero_avatar__894S-","content":"WelcomeHero_content__IZ1Q3","hello":"WelcomeHero_hello__Y02Y2"};